import { render } from "./persistentvolumeclaim.vue?vue&type=template&id=0edffb6d"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js"

import "./persistentvolumeclaim.vue?vue&type=style&index=0&id=0edffb6d&lang=scss"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__